import { checkAccount } from "../util/checkAccount.ts";
import { defineView } from "../util/defineView.ts";
import type { RouteParams } from "../../ui/router/types.ts";

const processInputs = (params: RouteParams<"account">, ctxBBGM: any) => {
	return {
		goldMessage: ctxBBGM.goldResult ? ctxBBGM.goldResult.message : undefined,
		goldSuccess: ctxBBGM.goldResult ? !!ctxBBGM.goldResult.success : undefined,
	};
};

// For subscribers who have not renewed yet, give them a 3 day grace period before showing ads again, because sometimes it takes a little extra tim for the payment to process
const GRACE_PERIOD = 60 * 60 * 24 * 3;

export default defineView({
	id: "account",
	processInputs,
	load: async ({ inputs, updateEvents, conditions }) => {
		if (updateEvents.has("firstRun") || updateEvents.has("account")) {
			const partialTopMenu = await checkAccount(conditions);
			const loggedIn =
				partialTopMenu.username !== undefined &&
				partialTopMenu.username !== null &&
				partialTopMenu.username !== "";
			const goldUntilDate = new Date(partialTopMenu.goldUntil * 1000);
			const goldUntilDateString = goldUntilDate.toDateString();
			const currentTimestamp = Math.floor(Date.now() / 1000) - GRACE_PERIOD;
			const showGoldActive =
				loggedIn &&
				!partialTopMenu.goldCancelled &&
				currentTimestamp < partialTopMenu.goldUntil;
			const showGoldCancelled =
				loggedIn &&
				partialTopMenu.goldCancelled &&
				currentTimestamp < partialTopMenu.goldUntil;
			const showGoldPitch = !loggedIn || !showGoldActive;

			return {
				email: partialTopMenu.email,
				goldMessage: inputs.goldMessage,
				goldSuccess: inputs.goldSuccess,
				goldUntilDateString,
				loggedIn,
				showGoldActive,
				showGoldCancelled,
				showGoldPitch,
				username: partialTopMenu.username,
			};
		}
	},
});
